var _circle, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup220(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "url(#paint0_radial)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.05 73.9001C32.35 72.8001 30.25 71.5001 30.25 70.1001C30.25 68.7001 32.35 67.4001 36.05 66.4001C39.75 65.5001 44.75 65.0001 50.05 65.0001C55.35 65.1001 60.35 65.7001 64.05 66.7001C67.75 67.8001 69.85 69.1001 69.85 70.5001C69.85 71.9001 67.75 73.2001 64.05 74.2001C60.35 75.1001 55.35 75.6001 50.05 75.6001C44.75 75.6001 39.75 75.0001 36.05 73.9001ZM65.65 66.4001C57.05 64.0001 43.05 63.8001 34.45 66.0001C25.85 68.2001 25.85 71.9001 34.45 74.3001C43.05 76.7001 57.05 76.9001 65.65 74.7001C74.25 72.5001 74.25 68.9001 65.65 66.4001Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.8484 40.2L50.0484 24L40.2484 40.3C39.2484 42 38.6484 44.1 38.6484 46.2V46.6C38.6484 52.8 43.7484 58 50.0484 58C56.2484 58 61.4484 52.9 61.4484 46.6V46.1C61.4484 44.1 60.8484 42.1 59.8484 40.2ZM57.9484 46.7C57.9484 51.2 54.3484 54.8 49.8484 54.8C45.3484 54.8 41.7484 51.2 41.7484 46.7V46.1C41.7484 44.7 42.1484 43.2 42.9484 41.9L49.8484 30.3L56.7484 41.9C57.4484 43.2 57.9484 44.6 57.9484 46.1V46.7Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(45) scale(141.421 171.504)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0DD0DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F80ED"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup220);
export default __webpack_public_path__ + "static/media/Group_220.90367e84cc413b9eee08d6c8ac8cb33d.svg";
export { ForwardRef as ReactComponent };